import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../_services/auth.sevice';
declare const Buffer;

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private auth: AuthService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: {
        'Content-Type': 'application/json',
        Authorization: 'Basic ' + Buffer.from('kecms:kecmskedos').toString('base64')
      }
    });
    if (this.auth.isLogged && this.auth.token && request.body && request.method === 'POST') {
      request.body.token = this.auth.token;
      request.body.idUtente = this.auth.userId;
    }
    return next.handle(request);
  }
}
